export default function money(value: number): string {
	return new Intl.NumberFormat("pt-br", { style: "currency", currency: "BRL" }).format(value);
}
